module.exports = __webpack_public_path__ + "img/banner1.a65f15be.jpg";